import { render, staticRenderFns } from "./DisplaySettingsIcon.vue?vue&type=template&id=af36a1aa"
import script from "./DisplaySettingsIcon.vue?vue&type=script&lang=ts"
export * from "./DisplaySettingsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports